import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { APP_VERSION } from "../AppVariables";
//import i18n from "i18next";

function CoBrowse() {
  useEffect(() => {
    //console.log("cobrowse effect");
    return () => {
      //console.log("cobrowse effect done");
    };
  });
  return (
    <div className="application">
      <Helmet>
        <title>Opencards - V{APP_VERSION}</title>
        <script src={"/opencards/js/cobrowse2.js"}></script>
        <script src={"/opencards/js/freshchat2.js"}></script>
      </Helmet>
    </div>
  );
}
export default CoBrowse;
